import { render, staticRenderFns } from "./SeriesDetail.vue?vue&type=template&id=43befc96&scoped=true&"
import script from "./SeriesDetail.vue?vue&type=script&lang=js&"
export * from "./SeriesDetail.vue?vue&type=script&lang=js&"
import style0 from "./SeriesDetail.vue?vue&type=style&index=0&id=43befc96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43befc96",
  null
  
)

export default component.exports